// This is not in numerical order, needs to match up to what the API expects
export enum OrgPlansColumnIndex {
  name = '1',
  subtitle = '6',
  targetType = '5',
  visibility = '2',
  followers = '3',
}
